import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from '../session.service';

@Component({
  selector: 'app-match-detail-date-meta',
  standalone: true,
  templateUrl: './match-detail-date-meta.component.html',
  styleUrl: './match-detail-date-meta.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MatchDetailDateMetaComponent {
  private readonly session = inject(SessionService);
  private readonly translate = inject(TranslateService, { optional: true });
  readonly scheduledAt = input.required<string>();
  readonly timeLabel = input.required<string>();
  readonly inline = input(false);

  readonly resolvedDateLabel = computed(() => {
    const scheduledDate = new Date(this.scheduledAt());
    const language = this.session.currentLanguage();
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    if (isSameCalendarDate(scheduledDate, today)) {
      return this.t('matchDetail.date.today');
    }

    if (isSameCalendarDate(scheduledDate, tomorrow)) {
      return this.t('matchDetail.date.tomorrow');
    }

    return new Intl.DateTimeFormat(language, {
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    }).format(scheduledDate);
  });

  private t(key: string): string {
    this.session.currentLanguage();

    const instantValue = this.translate?.instant(key);
    return typeof instantValue === 'string' ? instantValue : key;
  }
}

function isSameCalendarDate(left: Date, right: Date): boolean {
  return (
    left.getFullYear() === right.getFullYear() &&
    left.getMonth() === right.getMonth() &&
    left.getDate() === right.getDate()
  );
}
